import { render } from "./EventCard.vue?vue&type=template&id=33b8cf99&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=33b8cf99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33b8cf99"

export default script